const API_URL = 'https://myfinance.devaquila.me/backend';

class ApiService {
  constructor() {
    this.token = localStorage.getItem('token');
  }

  setToken(token) {
    this.token = token;
    localStorage.setItem('token', token);
  }

  removeToken() {
    this.token = null;
    localStorage.removeItem('token');
  }

  async request(endpoint, options = {}) {
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }

    const config = {
      ...options,
      headers,
    };

    try {
      const response = await fetch(`${API_URL}/${endpoint}`, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || data.message || 'Request failed');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // Auth endpoints
  async register(userData) {
    return this.request('auth/register', {
      method: 'POST',
      body: JSON.stringify(userData),
    });
  }

  async login(credentials) {
    const data = await this.request('auth/login', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });
    
    if (data.success && data.token) {
      this.setToken(data.token);
    }
    
    return data;
  }

  async logout() {
    await this.request('auth/logout', { method: 'POST' });
    this.removeToken();
  }

  // User endpoints
  async getProfile() {
    return this.request('user');
  }

  async updateProfile(profileData) {
    return this.request('user', {
      method: 'PUT',
      body: JSON.stringify(profileData),
    });
  }

  async updatePassword(passwordData) {
    return this.request('user', {
      method: 'PUT',
      body: JSON.stringify({ ...passwordData, update_type: 'password' }),
    });
  }

  // Transaction endpoints
  async getTransactions() {
    return this.request('transactions');
  }

  async getTransaction(id) {
    return this.request(`transactions/${id}`);
  }

  async createTransaction(transactionData) {
    return this.request('transactions', {
      method: 'POST',
      body: JSON.stringify(transactionData),
    });
  }

  async updateTransaction(id, transactionData) {
    return this.request(`transactions/${id}`, {
      method: 'PUT',
      body: JSON.stringify(transactionData),
    });
  }

  async deleteTransaction(id) {
    return this.request(`transactions/${id}`, {
      method: 'DELETE',
    });
  }

  async getSummary() {
    return this.request('transactions?summary=true');
  }
}

export default new ApiService();
